import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { useFetch } from "@/lib/api";
import { Mail, MapPin, Flame } from "lucide-react";

const cols = [
  {
    title: "The Ministry",
    links: [
      { label: "About the Ministry", to: "/about" },
      { label: "Our Evangelism", to: "/evangelism" },
      { label: "Departments", to: "/departments" },
      { label: "Leadership", to: "/leadership" },
    ],
  },
  {
    title: "Get Involved",
    links: [
      { label: "Events", to: "/events" },
      { label: "Prayer Requests", to: "/prayer-requests" },
      { label: "Partner / Give", to: "/giving" },
      { label: "Contact Us", to: "/contact" },
    ],
  },
  {
    title: "Media",
    links: [
      { label: "Sermons", to: "/sermons" },
      { label: "Podcasts", to: "/podcasts" },
      { label: "Videos", to: "/videos" },
      { label: "Gallery", to: "/gallery" },
    ],
  },
];

export const Footer = () => {
  const { data: ministry } = useFetch("/ministry");
  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Logo variant="light" src={ministry?.logo} />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              An International and Interdenominational Evangelism Ministry.
            </p>
            <p className="mt-4 font-display text-sm font-semibold text-brand-orange">
              Setting the World on Fire, One Nation at a time.
            </p>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="overline text-white/50">{col.title}</h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-white/70 transition-colors hover:text-brand-orange"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 border-t border-white/10 pt-8">
          <div className="flex flex-col gap-4 text-sm text-white/50 md:flex-row md:items-center md:justify-between">
            <div className="flex flex-wrap items-center gap-6">
              <span className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-brand-orange" /> {ministry?.contact?.email || "Contact details coming soon"}
              </span>
              <span className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-brand-orange" /> {ministry?.contact?.address || "Location coming soon"}
              </span>
            </div>
            <span className="flex items-center gap-2">
              <Flame className="h-4 w-4 text-brand-orange" />
              © {new Date().getFullYear()} Flames of Fire World Evangelism
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
